import { Card, Grid, Typography } from "@material-ui/core";
import React from "react";
import "./Volunteers.css";
// import $ from "jquery";
import Typical from "react-typical";
import ReactOwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.min.css";
import "owl.carousel/dist/assets/owl.theme.default.min.css";

function Volunteers() {
  return (
    <div className="volunteer" id="volunteer">
      <h2 className="title">
        <Typical
          loop={Infinity}
          wrapper="b"
          steps={[
            "Volunteer works",
            9000,
            "What I do For helping social.",
            2000,
          ]}
        ></Typical>
      </h2>
      <div className="max-width">
        <ReactOwlCarousel items="1" dots loop margin={15}>
          {/* <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={6}> */}
          <Card className="cards">
            <div className="box">
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="image">
                    <img src="./image/vangvieng.jpg" alt="donation" />
                  </div>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="card-text">
                    <Typography className="text1">
                      1. Donation at VangVieng city.
                    </Typography>
                    <Typography className="text2">
                      ໃນວັນທີ່ 1/6/2019 ເຊີ່ງເປັນວັນເດັກນ້ອຍສາກົນ
                      ນ້ອງໄດ້ໄປເປັນອາສາສະໝັກນຳ ບ້ານອາສາ ແລະ
                      ມົດແດງໄຟເພື່ອໄປຈັດງານວັນເດັກໃຫ້ນ້ອງໆທີ່ຢູ່ບ້ານຫ້ວຍງາມ
                      ເມືອງວັງວຽງແຂວງວຽງຈັນຈຳນວນ2 ມື້.
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Card>

          <Card className="cards">
            <div className="box">
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="image">
                    <img src="/image/nakai.jpg" alt="nakai" />
                  </div>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="card-text">
                    <Typography className="text1">
                      2. Volunteer Exchange.
                    </Typography>
                    <Typography className="text2">
                      ນ້ອງໄດ້ໄປເປັນອາສາສະໝັກນໍາສູນມູນິທິຮ່ວມໃຈທໍາ (Join Moral
                      Foundation) ເພື່ອໄປແລກປ່ຽນ,ຢ້ຽມຢາມ ແລະ
                      ນໍາພາອາສາສະໝັກທີ່ສູນໜອງບົວຄໍາ,ເມືອງນາກາຍ.
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Card>
          <Card className="cards">
            <div className="box">
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="image">
                    <img src="./image/x9.jpg" alt="donation" />
                  </div>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="card-text">
                    <Typography className="text1">
                      3. XiangMiang Volunteer.
                    </Typography>
                    <Typography className="text2">
                      ວັນທີ່ 22/3/2020 ຫາ ວັນທີ່ 29/12/2020
                      ຕົວນ້ອງເອງໄດ້ເຂົ້າຮ່ວມເປັນອາສາສະໝັກໃຫ້ກັບສະມາຄົມຊ້ຽງໝ້ຽງ
                      ເຊີ່ງເປັນໂຄງການສ້າງທັກສະທາງດ້ານເຕັກໂນໂລຊີດີຈີຕອນ ແລະ
                      ການເປັນຜູ້ປະກອບການໄວໜຸ່ມ 2020.
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Card>
          <Card className="cards">
            <div className="box">
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="image">
                    <img src="./image/thatluang.jpg" alt="donation" />
                  </div>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="card-text">
                    <Typography className="text1">
                      4. Thatluang Ground.
                    </Typography>
                    <Typography className="text2">
                      ໃນວັນທີ່ 9/11/2019 ຫາ 10/11/2019 ເຊີ່ງເປັນບູນທາດຫລວງ
                      ນ້ອງໄດ້ໄປເປັນອາສາສະໝັກເກັບຂີ້ເຫຍື້ອນຳ ສູນການສຶກສາ ແລະ
                      ວັດທະນະທໍາເດັກ (Children’s Education and culture Center).
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Card>
          <Card className="cards">
            <div className="box">
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="image">
                    <img src="./image/teaching.jpg" alt="donation" />
                  </div>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <div className="card-text">
                    <Typography className="text1">
                      5. Volunteer teaching.
                    </Typography>
                    <Typography className="text2">
                      ໃນວັນທີ່ 28-29/12/2019
                      ນ້ອງໄດ້ໄປເປັນຄູອາສາສອນພາສາຈີນນໍາມູນິທິຮ່ວມໃນທໍາ ( Join
                      Moral Foundation ).
                      ຢູ່ທີ່ໂຮງຮຽນປະຖົມສົມບູນບ້ານປາກກວາງ,ເມືອງປາກງື່ມ,ນະຄອນຫລວງວຽງຈັນ.
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Card>
          {/* </Grid>
          </Grid> */}
        </ReactOwlCarousel>
      </div>
    </div>
  );
}

export default Volunteers;
